import React, { Component } from "react";

class Stats extends Component {
  componentDidMount() {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll(".counter").forEach((el) => {
            const target = +el.dataset.t;
            const step = 16;
            const inc = target / (1200 / step);
            let cur = 0;
            const timer = setInterval(() => {
              cur = Math.min(cur + inc, target);
              el.textContent = Math.floor(cur);
              if (cur >= target) clearInterval(timer);
            }, step);
          });
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.1 }
    );

    const el = document.getElementById("stats");
    if (el) obs.observe(el);
  }

  render() {
    const ui = this.props.resumeBasicInfo?.ui || {};
    return (
      <div id="stats">
        <div className="stats-inner">
          <a href="#projects" className="stat-box">
            <span className="stat-label">{ui.stat1 || "Finished Projects"}</span>
            <span className="stat-num">
              <span className="counter" data-t="14">0</span>
              <sup>+</sup>
            </span>
          </a>
          <a href="#projects" className="stat-box">
            <span className="stat-label">{ui.stat2 || "Games on Steam"}</span>
            <span className="stat-num">
              <span className="counter" data-t="3">0</span>
            </span>
          </a>
          <a href="#experience" className="stat-box">
            <span className="stat-label">{ui.stat3 || "Studios Worked"}</span>
            <span className="stat-num">
              <span className="counter" data-t="5">0</span>
              <sup>+</sup>
            </span>
          </a>
          <a href="#certs" className="stat-box">
            <span className="stat-label">{ui.stat4 || "Certifications"}</span>
            <span className="stat-num">
              <span className="counter" data-t="16">0</span>
            </span>
          </a>
        </div>
      </div>
    );
  }
}

export default Stats;
